<mobile-pwa-update-banner />
<router-outlet />
